import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 3a1 1 0 0 1 0 2h-6a1 1 0 1 1 0 -2z","key":"svg-0"}],["path",{"d":"M20 3a1 1 0 0 1 0 2h-6a1 1 0 0 1 0 -2z","key":"svg-1"}],["path",{"d":"M8 7a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3z","key":"svg-2"}],["path",{"d":"M18 7a3 3 0 0 1 3 3v2a3 3 0 0 1 -3 3h-2a3 3 0 0 1 -3 -3v-2a3 3 0 0 1 3 -3z","key":"svg-3"}]]

const IconLayoutKanbanFilled = createReactComponent('filled', 'layout-kanban-filled', 'LayoutKanbanFilled', __iconNode);

export default IconLayoutKanbanFilled;